import { frontendURL } from 'dashboard/helper/URLHelper.js';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/pipeline'),
    name: 'crm_pipeline_index',
    meta: {
      permissions: ['administrator'],
    },
    component: () => import('./Pipeline.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/pipeline/analytics'),
    name: 'crm_marketing_analytics',
    meta: {
      requiresAuth: true,
      permissions: ['administrator', 'agent'],
    },
    component: () => import('./MarketingAnalytics.vue'),
  },
  {
    path: frontendURL('accounts/:accountId/pipeline/deals/:dealId'),
    name: 'crm_deal_workspace',
    meta: {
      requiresAuth: true,
      permissions: ['administrator'],
    },
    component: () => import('./DealWorkspace.vue'),
  },
];
